import axiosM from "axios";
import store from "../store/store";

// axiosM.defaults.withCredentials = true;
var axios = axiosM.create({ withCredentials: true });
export let setInterceptors = (url) => {
  // Request interceptor for Meetnet
  const baseURL = url || localStorage.getItem("meetnetBaseURL");
  axios.defaults.baseURL = baseURL;
  axios.interceptors.request.use(
    (config) => {
      if (config.url.includes(`${baseURL}/api/sensoren/`)) {
        config.headers["Authorization"] =
          "jwt " + localStorage.getItem("meetnetJWT");
      }
      // config.withCredentials = true;
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );

  //Response interceptor for Meetnet
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      console.log("response intcpt ERROR ");
      const originalRequest = error.config;

      if (
        error.response &&
        error.response.status === 403 &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true;
        const casJWT = localStorage.getItem("jwt");
        return axios({
          method: "POST",
          headers: { Authorization: "jwt " + casJWT },
          url: `/api-token-auth`,
        })
          .then((response) => {
            store.dispatch("setMeetnetJWT", response.data.token);
            axios.defaults.headers.common["Authorization"] =
              "jwt " + response.data.token;
            return axios(originalRequest);
          })
          .catch((error) => {
            console.log("retry authenticateMeetnet error", error);
          });
      } else if (
        error.response &&
        error.response.status === 403 &&
        originalRequest._retry
      ) {
        console.log("after retry unauthenticate", error.response);
      }
    }
  );
  return axios;
};
export default axios;
